<template>
  <div class="content1">
    <!-- PC端 -->
    <div class="pc" v-if="mobileFlag">
      <!-- 查询条件 -->
      <div class="query_con">
        <div class="query-header">
          <el-form :inline="true" :model="query" size="medium">
            <el-form-item label="日期范围">
              <el-date-picker
                v-model="query.dateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 300px"
                clearable
                @change="queryData"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!-- 顶部统计卡片 -->
      <div class="total-cards">

        <div class="card-item">
          <div class="icon-box icon-yellow">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="#ffb800">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-12h2v6h-2zm0 8h2v2h-2z"/>
            </svg>
          </div>
          <div>
            <div class="card-label">累计积分总额</div>
            <div class="card-value">{{ totalInfo.totalScore }}</div>
          </div>
        </div> 
      </div>

      <!-- 图表区域 -->
      <div class="chart-con">
        <!-- 积分分布饼图 -->
        <div class="chart-box">
          <div class="chart-title">积分分布</div>
          <div class="chart-content">
            <div ref="pie1" style="width: 350px; height: 300px;"></div>
            <el-table :data="pie1Data" border style="flex: 1;">
              <el-table-column prop="pointRange" label="积分" align="center" />
              <el-table-column prop="userCount" label="账号数量" align="center" />
              <el-table-column prop="userPercentage" label="占比（%）" align="center" />
            </el-table>
          </div>
        </div>

        <!-- 发放积分饼图 -->
        <div class="chart-box">
          <div class="chart-title">发放积分</div>
          <div class="chart-content">
            <div ref="pie2" style="width: 350px; height: 300px;"></div>
            <el-table :data="pie2Data" border style="flex: 1;">
              <el-table-column prop="sourceTypeName" label="积分发放方式" align="center" />
              <el-table-column prop="totalPoints" label="积分值" align="center" />
              <el-table-column prop="percentage" label="占比（%）" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="mobile" v-else>
      <div class="mobile_full">移动端</div>
    </div>
  </div>
</template>

<script>
import api from '@/apis/medal';
import moment from 'moment';
import { redirectRoute } from '@/utils/tools';
import * as echarts from 'echarts';

export default {
  name: 'ScoreStatistics',
  data() {
    return {
      query: {
        dateRange: []
      },
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      mobileFlag: false,
      pie1: null,
      pie2: null,
      // 顶部统计
      totalInfo: {
        availableScore: 0,
        totalScore: 0,
        usedScore: 0
      },
      // 饼图表格
      pie1Data: [],
      pie2Data: []
    };
  },
  mounted() {
    this.redirect();
    this.$nextTick(() => {
      this.initPieChart();
      this.queryData();
    });
  },
  beforeDestroy() {
    if (this.pie1) this.pie1.dispose();
    if (this.pie2) this.pie2.dispose();
  },
  methods: {
    redirect() {
      this.mobileFlag = redirectRoute();
    },

    // 初始化饼图
    initPieChart() {
      const pie1Dom = this.$refs.pie1;
      if (pie1Dom) {
        this.pie1 = echarts.init(pie1Dom);
      }

      const pie2Dom = this.$refs.pie2;
      if (pie2Dom) {
        this.pie2 = echarts.init(pie2Dom);
      }
    },

    // ======================
    // 已按你的字段完美对接
    // ======================
    async queryData() {
      this.tableLoading = true;
      try {
        // 日期范围格式化
        const startTime = this.query.dateRange?.[0]
          ? moment(this.query.dateRange[0]).format('YYYY-MM-DD 00:00:00')
          : '';
        const endTime = this.query.dateRange?.[1]
          ? moment(this.query.dateRange[1]).format('YYYY-MM-DD 23:59:59')
          : '';

        const params = { startTime, endTime };

        // 1. 积分分值范围统计
        const distributionRes = await api.totalPointsDistribution(params);
        const distributionList = distributionRes.data || [];

        // 2. 积分来源统计
        const sourceRes = await api.sourceStatistics(params);
        const sourceList = sourceRes.data || [];

        // 表格赋值（完全按你写的 prop）
        this.pie1Data = distributionList;
        this.pie2Data = sourceList;

        // 渲染图表
        this.renderPie1(distributionList);
        this.renderPie2(sourceList);

        // 顶部统计（接口无则显示0）
        this.totalInfo.totalScore = sourceList.reduce((sum, item) => sum + (item.totalPoints || 0), 0);
        this.totalInfo.usedScore = 0;
        this.totalInfo.availableScore = this.totalInfo.totalScore - this.totalInfo.usedScore;

      } catch (err) {
        console.error(err);
        this.$message.error('数据加载失败');
      } finally {
        this.tableLoading = false;
      }
    },

    // 积分分布饼图
    renderPie1(list) {
      const data = list.map(item => ({
        value: item.userCount || 0,
        name: item.pointRange || '-'
      }));

      this.pie1.setOption({
        tooltip: { trigger: 'item' },
        series: [
          {
            name: '积分分布',
            type: 'pie',
            radius: ['40%', '70%'],
            data,
            label: {
              formatter: '{b}',
              fontSize: 12,
              color: '#333',
              lineHeight: 16,
              overflow: 'break',
              line: {
                length: 10,
                length2: 15
              }
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 15
            }
          }
        ]
      });
    },

    // 发放积分饼图
    renderPie2(list) {
      const data = list.map(item => ({
        value: item.totalPoints || 0,
        name: item.sourceTypeName || '-'
      }));

      this.pie2.setOption({
        tooltip: { trigger: 'item' },
        series: [
          {
            name: '发放积分',
            type: 'pie',
            radius: ['40%', '70%'],
            data,
            label: {
              formatter: '{b}',
              fontSize: 12,
              color: '#333',
              lineHeight: 16,
              overflow: 'break',
              line: {
                length: 10,
                length2: 15
              }
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 15
            }
          }
        ]
      });
    },

    handleSizeChange1(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    handleCurrentChange1(val) {
      this.pageData.page = val;
      this.queryData();
    },
    exportRecord() {
      const startTime = this.query.dateRange?.[0]
        ? moment(this.query.dateRange[0]).format('YYYY-MM-DD 00:00:00')
        : '';
      const endTime = this.query.dateRange?.[1]
        ? moment(this.query.dateRange[1]).format('YYYY-MM-DD 23:59:59')
        : '';
      const params = { startTime, endTime };
      api.scoreStatExport(params).then(res => {
        const url = URL.createObjectURL(new Blob([res]));
        const a = document.createElement('a');
        a.href = url;
        a.download = '积分统计报表.xlsx';
        a.click();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content1 {
  min-height: 100vh;
  padding: 10px 0;
  background-color: #f2fcf9;

  // 查询头部
  .query-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
  }

  .query_con {
    padding: 20px 0 0;

    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }

  // 统计卡片
  .total-cards {
    display: flex;
    gap: 190px;
    margin: 20px 40px;

    .card-item {
      display: flex;
      align-items: center;
      gap: 20px;

      .icon-box {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        &.icon-yellow {
          background: #ffb80020;
        }
      }

      .card-label {
        font-size: 28px;
        color: #666;
        margin-bottom: 10px;
      }

      .card-value {
        font-size: 28px;
        font-weight: bold;
      }
    }
  }

  // 图表容器
  .chart-con {
    display: flex;
    margin: 0 40px;
    gap: 20px;

    .chart-box {
      flex: 1;
      padding: 20px;
      border-radius: 12px;
      background: #f0f0f0;

      .chart-title {
        margin-bottom: 10px;
        font-weight: bold;
      }

      .chart-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
      }
    }
  }

  .table_con {
    margin: 20px 40px 0;
    padding: 20px;
    border-radius: 5px;
    background: #fff;
    border: 1px solid #e2e6e5;
  }

  .pagination_con {
    display: flex;
    justify-content: flex-end;
    margin: 20px 40px 0 0;
  }
}
</style>